module.exports = __webpack_public_path__ + "static/notification-42233896d7578f33d0f353b9286858c4.svg";